var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgConsulting4(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 34,
    height: 32,
    viewBox: "0 0 34 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2188_7158)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M28.9 17.6H23.8C20.9831 17.6 18.7 19.7488 18.7 22.4V27.2C18.7 29.8512 20.9831 32 23.8 32H28.9C31.7169 32 34 29.8512 34 27.2V22.4C34 19.7488 31.7169 17.6 28.9 17.6ZM10.2 17.6H5.1C2.2831 17.6 0 19.7488 0 22.4V27.2C0 29.8512 2.2831 32 5.1 32H10.2C13.0169 32 15.3 29.8512 15.3 27.2V22.4C15.3 19.7488 13.0169 17.6 10.2 17.6ZM28.9 0H23.8C20.9831 0 18.7 2.1488 18.7 4.8V9.6C18.7 12.2512 20.9831 14.4 23.8 14.4H28.9C31.7169 14.4 34 12.2512 34 9.6V4.8C34 2.1488 31.7169 0 28.9 0ZM15.3 4.8V9.6C15.3 12.2512 13.0169 14.4 10.2 14.4H5.1C2.2831 14.4 0 12.2512 0 9.6V4.8C0 2.1488 2.2831 0 5.1 0H10.2C13.0169 0 15.3 2.1488 15.3 4.8Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2188_7158"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 34,
    height: 32,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgConsulting4);
export default __webpack_public_path__ + "static/media/consulting-4.3628e41472c8bf8e2d21c8d77ad988aa.svg";
export { ForwardRef as ReactComponent };